import { useMemo } from "react";

const useMonthCalendar = (
  date,
  appointments = [],
  employeeColors = [],
  unavailableEmployees = [],
) => {
  const daysName = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const getEmployeeColor = (name) => {
    return (
      employeeColors.find((item) => item.name === name)?.color || "#849b8c"
    );
  };

  const days = useMemo(() => {
    const year = date.getFullYear();
    const month = date.getMonth();

    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);

    const monthDays = [];

    // Empty cells before first day
    for (let i = 0; i < firstDay.getDay(); i++) {
      monthDays.push(null);
    }

    // Month days
    for (let i = 1; i <= lastDay.getDate(); i++) {
      monthDays.push(new Date(year, month, i));
    }
    // Always 5 weeks
    while (monthDays.length < 35) {
      monthDays.push(null);
    }
    if (monthDays.length > 35) {
      while (monthDays.length < 42) {
        monthDays.push(null);
      }
    }
    return monthDays.slice(0, monthDays.length);
  }, [date]);

  const sameDay = (d1, d2) => {
    return (
      d1 &&
      d2 &&
      d1.getDate() === d2.getDate() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getFullYear() === d2.getFullYear()
    );
  };

  // Group appointments once for better performance
  const unavailableEmployeePerDate = useMemo(() => {
    return unavailableEmployees.reduce((acc, app) => {
      const key = new Date(app.date).toDateString();

      if (!acc[key]) {
        acc[key] = [];
      }

      acc[key].push(app);

      return acc;
    }, {});
  }, [unavailableEmployees]);

  // Group appointments once for better performance
  const appointmentsByDate = useMemo(() => {
    return appointments.reduce((acc, app) => {
      const key = new Date(app.date).toDateString();

      if (!acc[key]) {
        acc[key] = [];
      }

      acc[key].push(app);

      return acc;
    }, {});
  }, [appointments]);
  const getEvents = (day) => {
    if (!day) return [];
    var x = appointmentsByDate[day.toDateString()] || [];
    var y = unavailableEmployeePerDate[day.toDateString()] || [];

    const addOverlapColumnss = addOverlapColumns(x, y);

    return addOverlapColumnss || [];
  };
  const addOverlapColumns = (appointments, unavailables) => {
    const events = [
      ...appointments.map((appointment) => ({
        ...appointment,
        type: "appointment",
      })),

      ...unavailables.map((unavailable) => ({
        ...unavailable,
        type: "unavailable",
      })),
    ];
    const sorted = [...events].sort((a, b) =>
      a.startTime.localeCompare(b.startTime),
    );

    const groups = [];
    const result = [];

    sorted.forEach((app) => {
      let group = groups.find((g) =>
        g.some(
          (item) =>
            app.startTime < item.endTime && app.endTime > item.startTime,
        ),
      );

      if (!group) {
        group = [];
        groups.push(group);
      }

      group.push(app);
    });

    groups.forEach((group) => {
      const totalColumns = group.length > 1 ? group.length : 1;

      group.forEach((app, index) => {
        result.push({
          ...app,
          column: index,
          totalColumns,
        });
      });
    });

    return result;
  };
  const isToday = (day) => {
    const today = new Date();

    return (
      day &&
      day.getDate() === today.getDate() &&
      day.getMonth() === today.getMonth() &&
      day.getFullYear() === today.getFullYear()
    );
  };

  return {
    daysName,
    days,
    getEvents,
    getEmployeeColor,
    isToday,
  };
};

export default useMonthCalendar;
